import React, { useEffect, useState } from "react";
import { downloadReglement, getReglements } from "../../../service/ScrbService";
import { DataView } from "primereact/dataview";
import { I18n } from "aws-amplify";
import { setCursorDefault, setCursorProgress } from "../ScrbTools";
import { Skeleton } from "primereact/skeleton";

export default function Reglements() {

    const [reglements, setReglements] = useState([]);
    const [isDownloading, setIsDownloading] = useState(false);

    useEffect(() => {
        getReglements().then(setReglements);
    }, []);

    const downloadFile = (key) => {
        setCursorProgress();
        setIsDownloading(true);
        downloadReglement(key).then(() => {
            setCursorDefault();
            setIsDownloading(false);
        });
    }

    const listTemplate = (reglements) => {
        return <div className="flex flex-wrap w-full column-gap-4 row-gap-4">
            {reglements.map(reglement => {
                const fileName = I18n.get(reglement.metadata.filename);
                const title = <span><i className="fa-light fa-file-pdf" style={{ fontSize: "2rem", color: "#DE3735" }}></i> <div className='pt-3 text-sm'>{fileName}</div></span>;
                return <button
                    key={reglement.key}
                    className={`border-1 border-round-xl border-300 w-20rem h-8rem bg-white hover:bg-blue-100`}
                    style={{ boxShadow: "0 0 0px 0 #395697", cursor: 'pointer' }}
                    onClick={() => downloadFile(reglement.key.split('/').pop())}
                    disabled={isDownloading}
                >
                    {title}
                </button>
            })}
        </div>;
    }

    return reglements.length > 0 ?
        <div>
            <div className="text-xl pb-2">{I18n.get("downloads")} :</div>
            {<DataView value={reglements} listTemplate={listTemplate} />}
        </div> :
        <div className="flex flex-column lg:flex-row flex-wrap gap-3">
            {[...Array(3)].map((_, index) => (
                <Skeleton key={index} width="20rem" height="10rem" />
            ))}
        </div>;
}